import React, {FC, useCallback, useEffect, useState} from 'react'
import {PaginateParams} from '../../../../../services/cellcast.v2.types'
import {
  useLazyGetAffiliateQuery,
  useLoginAsAffiliateUserMutation,
  useUserRequestAccessMutation,
} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {useLoadedData} from '../../../../hooks/useGetLoadedData'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import {Spinner} from 'react-bootstrap'
import moment from 'moment-timezone'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {useDispatch} from 'react-redux'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {resetRedux} from '../../../../Redux/store'
import {UpdateLoggedUserInfo} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../../_metronic/helpers'
import Select from 'react-select'

type AffiliateProps = {
  userData: any
}

const Affiliate: FC<AffiliateProps> = (props) => {
  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const [params, setParams] = useState<Partial<PaginateParams & {code?: string}>>({
    page: 1,
    limit: 10,
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [triggerFetch, setTriggerFetch] = useState(false)
  const [fetch, {isLoading, data, isFetching}] = useLazyGetAffiliateQuery()

  const [requestId, setRequestId] = useState('')
  const [requestAccess, requestAccessResponse] = useUserRequestAccessMutation()

  const [loginAsUser, loginAsUserResponse] = useLoginAsAffiliateUserMutation()
  const [codeOptions, setCodeOptions] = useState([])

  useEffect(() => {
    fetch(params)
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (
      props.userData &&
      props.userData.myReferralCodes &&
      Array.isArray(props.userData.myReferralCodes)
    ) {
      const activeCodes = props.userData.myReferralCodes.filter(
        (el: any) => el?.status && el?.status === 'active'
      )
      const codeOptions = activeCodes.map((el: any) => ({
        label: el?.code || '',
        value: el?.code || '',
      }))

      const options = [{label: 'Select Code', value: ''}, ...codeOptions]
      setCodeOptions(options as any)
    }
  }, [props.userData])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
      MenuComponent.reinitialization()
    }
  }, [isLoading, isFetching])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  const doRequest = (targetId: string) => {
    setRequestId(targetId.toString())
    requestAccess({
      targetId: targetId,
    })
      .then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else {
            doFetch(params)
            toast.success(res?.data?.message)
          }
        } else if ('error' in res) {
          const resError = res.error as any
          if (resError.data?.message) {
            toast.error(resError.data?.message || '')
          } else {
            toast.error(res?.error.toString() || '')
          }
        }
      })
      .finally(() => {
        setRequestId('')
      })
  }

  const getAccessStatusLabel = (status: string) => {
    switch (status) {
      case 'waiting':
        return <span className='badge badge-light-info'>need approval</span>
      case 'rejected':
        return <span className='badge badge-light-danger'>Rejected</span>
      case 'granted':
        return <span className='badge badge-light-success'>Granted</span>
      default:
        return <span className='badge badge-light-warning'>need request</span>
    }
  }

  const handleLoginAsUser = (id: string, useGlobalLoading: boolean) => {
    if (useGlobalLoading) dispatch(startLoadding())
    loginAsUser({targetUserId: id})
      .then((res: any) => {
        if (res?.data) {
          dispatch(resetRedux())
          const resData = res.data
          // reconfigure local storage
          localStorage.setItem('permission', JSON.stringify(resData.data.userPermissions))
          localStorage.setItem('currentUser', JSON.stringify(resData))
          localStorage.setItem('role', resData.data.user.role)
          localStorage.setItem('token', resData.data.token)
          localStorage.setItem('isAffiliateParent', 'true')

          dispatch(UpdateLoggedUserInfo(resData.data))
          navigate('/auth')
        } else if ('error' in res) {
          console.error('error login as user:', res.error)
          toast.error(res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        if (useGlobalLoading) dispatch(stopLoading())
      })
  }

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-5'>
          <h3 className='card-title align-items-start  flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Affiliate Users</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
          </h3>
          <div className='card-toolbar'>
            <button
              data-testid='btnFilterCommissions'
              className={`position-relative btn btn-light-primary filter_btn `}
              data-kt-menu-trigger='hover'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
              Filter
            </button>

            <div
              className={`position-absolute menu menu-sub menu-sub-dropdown w-250px w-md-300px `}
              data-kt-menu='true'
            >
              <div className='px-7 py-5'>
                <div className='mb-10'>
                  <label className='form-label fw-bold'>Commission Type:</label>
                  <Select
                    placeholder='Select Type'
                    value={
                      codeOptions.find((el: any) => el?.value === params?.code) || {
                        label: 'select code',
                        value: '',
                      }
                    }
                    options={codeOptions}
                    onChange={(e: any) => {
                      setParams({...params, code: e.value})
                      setTriggerFetch(true)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='max-w-100px'>Code</th>
                        <th className='min-w-150px'>Name</th>
                        <th className='min-w-140px'>Company</th>
                        <th className='min-w-140px'>Email</th>
                        <th className='min-w-100px'>JOINED-DATE</th>
                        <th className='min-w-100px text-center'>Access Status</th>
                        <th className='text-center'>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={5} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div
                                    className='text-mute text-center fs-8'
                                    style={{
                                      backgroundColor: 'rgb(245, 248, 250)',
                                      padding: '5px 10px',
                                      borderRadius: 5,
                                    }}
                                  >
                                    {item.referralCode}
                                  </div>
                                </td>
                                <td className='top-align'>{item.name || '--'}</td>
                                <td className='top-align'>{item.companyName || '--'}</td>
                                <td className='top-align'>{item.email || '--'}</td>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='top-align text-center'>
                                  {getAccessStatusLabel(item.referralParentAccessStatus)}
                                </td>
                                <td>
                                  <div className='d-flex justify-content-center'>
                                    <span
                                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                      data-kt-menu-trigger='hover'
                                      data-kt-menu-placement='bottom-end'
                                    >
                                      {requestAccessResponse.isLoading &&
                                      item._id.toString() === requestId ? (
                                        <Spinner size='sm' />
                                      ) : (
                                        <i className='bi bi-three-dots fs-5'></i>
                                      )}
                                    </span>
                                    <div
                                      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                                      data-kt-menu={'true'}
                                    >
                                      <div className='menu-item px-3'>
                                        <span
                                          className={`menu-link px-3 ${
                                            item.referralParentAccessStatus === 'granted' ||
                                            item.referralParentAccessStatus === 'waiting'
                                              ? 'text-muted'
                                              : ''
                                          }`}
                                          onClick={() => {
                                            if (
                                              item.referralParentAccessStatus === 'granted' ||
                                              item.referralParentAccessStatus === 'waiting' ||
                                              requestAccessResponse.isLoading
                                            ) {
                                              return
                                            }

                                            doRequest(item._id)
                                          }}
                                        >
                                          <i className='bi bi-key me-2'></i>Request Access
                                        </span>
                                      </div>

                                      {item.referralParentAccessStatus === 'granted' && (
                                        <div className='menu-item px-3'>
                                          <span
                                            className={`menu-link px-3`}
                                            onClick={() => {
                                              handleLoginAsUser(item._id, true)
                                            }}
                                          >
                                            <i className='bi bi-box-arrow-in-right me-2'></i>Login
                                            As User
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      setTriggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      setTriggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No affiliate user (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Affiliate
